import { Box } from '@thirdspacelearning/library';

import { RedirectActionPanel } from '@shared';

const NoMatch = () => {
    return (
        <Box
            width="100%"
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexGrow={1}
        >
            <RedirectActionPanel />
        </Box>
    );
};

export default NoMatch;
